import React, { useContext, useEffect, useReducer, useState } from "react";

import { useNavigate } from "react-router-dom";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";

import { APICall } from "../../Helpers/Network/APICalls";
import "./SanjivanSuvidha.css";

import {
  // getConfigValues,
  GetMemberDashboardDetails,
} from "../../Helpers/APIEndPoints/EndPoints";
const SuvidhaYojana = (props) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  // const [suvidhaDesc, setSuvidhaDesc] = useState("");
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  let navigate = useNavigate();
  const context = getContext();
  let MemberId = context.MemberId;
  const { appModule, suvidhaDesc } = props;

  // const callConfigData = async () => {
  //   const config = ["SuvidhaYojnaDescription"];
  //   showLoader();
  //   const result = await APICall(getConfigValues, { Keys: config });

  //   if (result.Data.length > 0) {
  //     result.Data.map((cd) => {
  //       if (cd.Key === "SuvidhaYojnaDescription") {
  //         setSuvidhaDesc(cd.Value);
  //       }
  //     });
  //     forceUpdate();
  //   }
  //   hideLoader();
  // };

  // const getDashboardData = async () => {
  //   showLoader();
  //   try {
  //     const obj = { MemberId };
  //     const resp = await APICall(GetMemberDashboardDetails, obj);

  //     const memberData = resp?.Data;
  //     setSuvidhaDesc(memberData?.Description_Suvidha);
  //     forceUpdate();
  //   } catch (error) {
  //     console.error("Error fetching dashboard data:", error);
  //   } finally {
  //     hideLoader();
  //   }
  // };

  // useEffect(() => {
  //   if (MemberId) {
  //     getDashboardData();
  //   }
  // }, [MemberId]);

  const handleApplyNowClick = () => {
    const YojnaType = "SuvidhaYojna";
    navigate("/SuvidhaMenu", { state: { YojnaType, appModule } });
  };

  return (
    <div className="my-card set-bgimg-suv">
      <h4 className="font-weight-bold text-center mb-3">Suvidha Yojana</h4>
      <p>{suvidhaDesc}</p>
      <div className=" red_btn text-center mt-3">
        <button
          className="text-center btn-submit"
          onClick={handleApplyNowClick}
        >
          <i className="fas fa-check"></i> Apply Now
        </button>
      </div>
    </div>
  );
};

export default SuvidhaYojana;
